/**
 *
 * MergeKeysSelect
 *
 */

import { Grid, Tab, Tabs, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';

import globalMessages from 'shared/global/messages';

import useStyles from './styles';

// TODO: Make separate endpoint for merge keys
// and change this component into container.
// Right now, mergeKeys payload is available only for FileRecollectionDrawer
// ^ fix needed to support for Send Email, Send SMS modal
export function MergeKeysSelect({
  intl,
  mergeKeys,
  handleMergeKeySelect,
  hasRequiredTab = true,
}) {
  const classes = useStyles();
  const [tabIndex, setTabIndex] = useState(0);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleTabChange = useCallback((event, newValue) => {
    setTabIndex(newValue);
  });

  const safeMergeKeys = mergeKeys || {};
  const recollectionKeys = safeMergeKeys.recollection?.keys || [];
  const openingKeys = safeMergeKeys.position_keys?.keys || [];
  const applicantKeys = safeMergeKeys.applicant_keys?.keys || [];
  const customKeys = safeMergeKeys.custom_keys?.keys || [];
  const customerAttributeKeys =
    safeMergeKeys.customer_attribute_keys?.keys || [];

  const requiredKeys = recollectionKeys.filter(key => key.required);

  const handleChange = keyObj => {
    const { key } = keyObj;
    handleMergeKeySelect(key); // inserts key into email, or SMS
  };

  // const allKeys = [
  //   ...requiredKeys,
  //   ...openingKeys,
  //   ...applicantKeys,
  //   ...customKeys,
  // ];

  const tabItems = [
    {
      messageId: 'applicant',
      keys: applicantKeys,
    },
    {
      messageId: 'opening',
      keys: openingKeys,
    },
    {
      messageId: 'custom',
      keys: customKeys,
    },
    ...(customerAttributeKeys.length > 0
      ? [
          {
            messageId: 'customerAttribute',
            keys: customerAttributeKeys,
          },
        ]
      : []),
  ];

  if (hasRequiredTab) {
    tabItems.unshift({
      messageId: 'required',
      keys: requiredKeys,
    });
  }

  // Filter to only show tabs that have keys
  const tabsWithKeys = tabItems.filter(
    item => item.keys && item.keys.length > 0,
  );

  useEffect(() => {
    if (tabIndex >= tabsWithKeys.length && tabsWithKeys.length > 0) {
      setTabIndex(0);
    }
  }, [tabIndex, tabsWithKeys.length]);

  return (
    <Grid
      container
      className={classes.mergeKeysSelect}
      direction="column"
      data-testid="merge-keys-select"
    >
      <Tabs
        classes={{
          root: classes.tabsRoot,
          flexContainer: classes.tabsFlexContainer,
        }}
        indicatorColor="primary"
        value={tabIndex}
        onChange={handleTabChange}
      >
        {tabsWithKeys.map(item => (
          <Tab
            key={item.messageId}
            classes={{ root: classes.tabRoot }}
            label={intl.formatMessage(globalMessages[item.messageId])}
          />
        ))}
      </Tabs>
      <Grid container className={classes.keysContainer}>
        {tabsWithKeys[tabIndex]?.keys.map(keyObj => (
          <Grid
            onClick={() => handleChange(keyObj)}
            container
            className={classes.key}
            key={keyObj.key}
          >
            <Typography
              variant="body2"
              color="textPrimary"
              title={keyObj.title}
              noWrap
            >
              {keyObj.title}
            </Typography>
            <Typography variant="body2" noWrap title={keyObj.key}>
              [{keyObj.key}]
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
}

MergeKeysSelect.propTypes = {
  intl: PropTypes.object.isRequired,
  mergeKeys: PropTypes.object,
  handleMergeKeySelect: PropTypes.func,
  hasRequiredTab: PropTypes.bool,
};

MergeKeysSelect.defaultProps = {
  mergeKeys: {},
};

export default memo(injectIntl(MergeKeysSelect));
